import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { FadeUp, GoldRule, Overline } from "./Motion";
import { SITE } from "../lib/site";

const ACTIONS = [
  { n: "I", t: "Busca e apreensão", d: "Quando o bem financiado com alienação fiduciária — veículo, máquina agrícola ou outro bem — tem parcelas em atraso, o banco pode pedir judicialmente a retomada do bem." },
  { n: "II", t: "Execução de título extrajudicial", d: "O credor cobra judicialmente uma dívida representada por um título, como cédula de crédito, contrato bancário ou nota promissória, podendo pedir bloqueios e penhoras." },
  { n: "III", t: "Ação monitória", d: "O credor tem uma prova escrita da dívida, mas sem força de título executivo, e pede ao juiz que reconheça o débito para depois cobrá-lo." },
];

export const Explainer = () => (
  <section data-testid="explainer-section" className="mx-auto max-w-[1360px] px-6 lg:px-10 py-24 md:py-36">
    <FadeUp className="max-w-3xl">
      <Overline>Entenda a sua situação</Overline>
      <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.02]">Três ações, um mesmo objetivo: <span className="italic text-gold-gradient">encontrar a saída.</span></h2>
    </FadeUp>
    <GoldRule className="mt-16" />
    <div className="grid md:grid-cols-3">
      {ACTIONS.map((a, i) => (
        <FadeUp key={a.t} delay={i * 0.12} className="group py-10 md:px-8 md:first:pl-0 border-b md:border-b-0 md:border-r last:border-0 border-[#D4AF37]/15">
          <span className="font-cinzel text-5xl text-[#D4AF37]/50 transition-colors duration-500 group-hover:text-[#D4AF37]">{a.n}</span>
          <h3 className="mt-6 font-display text-3xl text-white">{a.t}</h3>
          <p className="mt-4 text-base text-[#C0C9DC] leading-relaxed">{a.d}</p>
        </FadeUp>
      ))}
    </div>
  </section>
);

export const Manifesto = ({ image = "/img/agro.webp" }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);
  return (
    <section ref={ref} data-testid="manifesto-section" className="relative h-[80vh] min-h-[520px] overflow-hidden">
      <motion.img style={{ y }} src={image} alt="Lavoura ao pôr do sol" className="absolute inset-0 h-[124%] -top-[12%] w-full object-cover" />
      <span className="absolute inset-0 bg-gradient-to-b from-[#0B132B] via-[#0B132B]/40 to-[#0B132B]" />
      <div className="relative h-full mx-auto max-w-[1360px] px-6 lg:px-10 flex flex-col justify-center">
        <FadeUp>
          <p className="font-cinzel text-xs tracking-[0.4em] text-[#E6C687]">GRUPO AUGUSTINIS</p>
          <p className="mt-6 max-w-4xl font-display text-4xl sm:text-5xl lg:text-7xl text-white leading-[1.02]">
            {SITE.tagline.split(". ").map((s, i, arr) => (
              <span key={s} className={`block ${i === arr.length - 1 ? "italic text-gold-gradient" : ""}`}>{s}{i < arr.length - 1 ? "." : ""}</span>
            ))}
          </p>
        </FadeUp>
      </div>
    </section>
  );
};
